/**
 * @GENERATED from Figma node 3608:51031
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const NotionDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m5.144 20.812-2.293-2.857A3.84 3.84 0 0 1 2 15.553V5.21c0-1.303 1.042-2.384 2.387-2.476l10.634-.726a3.47 3.47 0 0 1 2.175.582l3.737 2.526A2.4 2.4 0 0 1 22 7.096v11.76c0 1.274-1.025 2.33-2.342 2.411l-11.802.727a3.22 3.22 0 0 1-2.712-1.182"
      clipRule="evenodd"
    />
    <path
      fill="#1E1919"
      d="M8.703 10.329v-.14c0-.356.286-.65.655-.675l2.686-.178 3.714 5.44v-4.775l-.956-.126v-.067c0-.36.293-.656.666-.675l2.444-.125v.35a.34.34 0 0 1-.29.333l-.589.1v7.733l-.738.252a1.436 1.436 0 0 1-1.656-.544l-3.606-5.413v5.166l1.11.211-.016.103a.69.69 0 0 1-.663.578l-2.76.122a.64.64 0 0 1 .581-.69l.363-.039v-6.888z"
    />
    <path
      fill="#1E1919"
      fillRule="evenodd"
      d="m15.243 3.005-11.066.752C3.514 3.802 3 4.332 3 4.97v10.707c0 .6.208 1.184.59 1.658l2.387 2.957c.385.479.993.742 1.62.703l12.283-.752c.63-.038 1.12-.54 1.12-1.147V6.923c0-.375-.19-.726-.51-.942l-3.888-2.615a2.17 2.17 0 0 0-1.359-.361M4.726 5.138c-.154-.114-.081-.35.112-.364l10.48-.747c.334-.024.665.067.935.258l2.103 1.482c.08.056.043.177-.056.183l-11.098.6a1.45 1.45 0 0 1-.935-.277zM6.68 8.432c0-.358.292-.655.664-.675l11.734-.635a.623.623 0 0 1 .668.607V18.27c0 .358-.29.654-.662.675l-11.66.66c-.403.023-.744-.286-.744-.675z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(NotionDark);
export { ForwardRef as NotionDark };
